"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DifferentialPairPolarityParametricSchema = exports.DifferentialPairPolarityParametric = void 0;
const zod_1 = require("zod");
var DifferentialPairPolarityParametric;
(function (DifferentialPairPolarityParametric) {
    DifferentialPairPolarityParametric["Positive"] = "p";
    DifferentialPairPolarityParametric["Negative"] = "n";
})(DifferentialPairPolarityParametric || (exports.DifferentialPairPolarityParametric = DifferentialPairPolarityParametric = {}));
exports.DifferentialPairPolarityParametricSchema = zod_1.z.nativeEnum(DifferentialPairPolarityParametric);
//# sourceMappingURL=DifferentialPairPolarityParametric.js.map